import { useEffect } from 'react'
import { createPortal } from 'react-dom'

export default function PopupImage({
  open,
  onClose,
  onHideForDay,
  imageUrl,
  linkUrl,
  alt = 'Promotion',
}) {
  useEffect(() => {
    if (!open) return
    const onKey = (e) => e.key === 'Escape' && onClose()
    document.addEventListener('keydown', onKey)
    document.body.classList.toggle('overflow-hidden', open)
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.classList.remove('overflow-hidden')
    }
  }, [open, onClose])

  if (!open) return null

  /*const Img = (
    <img
      src={imageUrl}
      alt={alt}
      loading='eager'
      className='block w-full h-auto max-h-[75vh] object-contain'
    />
  )*/

  const content = (
    <div className='fixed inset-0 z-[9999]'>
      <div className='absolute inset-0 bg-black/60' onClick={onClose} />
      <div
        className='
        relative mx-auto mt-16
        w-fit max-w-[92vw] sm:max-w-[640px]
        rounded-2xl shadow-2xl bg-white
        max-h-[85vh] overflow-auto
      '
        onClick={(e) => e.stopPropagation()}
      >
        {/* 닫기 버튼 */}
        <button
          aria-label='닫기'
          className='absolute right-3 top-3 rounded-full bg-black/60 px-3 py-1 text-sm text-white hover:bg-black/80'
          onClick={onClose}
        >
          닫기
        </button>

        {/* 이미지/링크 */}
        {linkUrl ? (
          <a href={linkUrl} target='_blank' rel='noreferrer'>
            <img
              src={imageUrl}
              alt={alt}
              loading='eager'
              className='block h-auto max-h-[75vh] max-w-full object-contain'
            />
          </a>
        ) : (
          <img
            src={imageUrl}
            alt={alt}
            loading='eager'
            className='block h-auto max-h-[75vh] max-w-full object-contain'
          />
        )}

        {/* 하단: 가운데 정렬 + 작은 필 버튼 */}
        <div className='sticky bottom-0 flex w-full items-center justify-center pb-3 pt-2 bg-white/90 backdrop-blur'>
          <button
            className='
            inline-flex items-center
            rounded-full border border-neutral-300
            px-3 py-1 text-xs text-neutral-700
            shadow-sm hover:bg-white focus:outline-none
            focus:ring-2 focus:ring-neutral-300
            translate-y-1
          '
            onClick={onHideForDay}
          >
            오늘 하루 보지 않기
          </button>
        </div>
      </div>
    </div>
  )

  return createPortal(content, document.body)
}
